import CircleAnchor from '@editor/pages/projects/editor/objects/EditorCircleAnchor'
import { useAppSelector } from '@editor/store/app'

import { Tools } from '../tools/setup'

const CurrentAnchorPosition = () => {
  // Store
  const currentAnchorPosition = useAppSelector((state) => state.toolUtil.core.currentAnchorPosition)
  const selectedTool = useAppSelector((state) => state.blueprint.editor.selectedTool)

  const currentTool = Tools.find((tool) => tool.key === selectedTool)

  return (
    !!currentTool?.config?.anchor?.showCurrentAnchor && (
      <CircleAnchor id="current-anchor" point={currentAnchorPosition || [0, 0, 0]} visible={!!currentAnchorPosition} />
    )
  )
}

export default CurrentAnchorPosition
